<script>
import {mapState} from "vuex";
import { useTheme } from "vuetify"

export default {
  name: "AnnotationMixin",
  computed: {
    ...mapState('topoProfilePoint', {
      options: state => state.options,
      items: state => state.items
    }),
    annotations() {
      let itemsAnnotate = this.items.filter(item => item.properties.name)
      return itemsAnnotate.map(item => {
        let displayName = this.getDisplayName(item.properties.name)
        displayName = displayName ? displayName : item.properties.name
        return {
          x: item.geometry.coordinates[0],
          y: item.geometry.coordinates[1],
          yshift: 10,
          yanchor: "bottom",
          textangle: '90',
          bgcolor: 'white',
          text: displayName,
          showarrow: false,
          ay: 40,
          hideToggle: true,
        }
      })
    },
    currentItemAnnotation() {
      return this.currentItem ? {
        x: this.currentItem.geometry.coordinates[0],
        y: this.currentItem.geometry.coordinates[1],
        xref: 'x',
        yref: 'y',
        showarrow: true,
        arrowhead: 7,
        arrowsize: 1.25,
        arrowcolor: '#0186A7',
        ax: 0,
        ay: 10,
        hideToggle: false,
      } : null
    },
  },
  methods: {
    getDisplayName(name) {
      return this.options?.name.choices.find(choice => choice.value === name)?.display_name
    }
  }
}
</script>

<style scoped>

</style>